module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-02@2x.070d4f6d.jpg";